"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
* <h4>Event type: ContentViewEventData</h4>
* Optionally pass in values for the name, contentId, contentVersionId, and viewedTime properties
**/
function createContentViewEventData(_a) {
    var product = _a.product, ipAddress = _a.ipAddress, latitude = _a.latitude, longitude = _a.longitude, extraProperties = _a.extraProperties, correlationId = _a.correlationId, name = _a.name, contentId = _a.contentId, contentVersionId = _a.contentVersionId, _b = _a.viewedTime, viewedTime = _b === void 0 ? new Date() : _b, // probably will want to change this to use Moment.js!
    contentProfileId = _a.contentProfileId, workspaceContentId = _a.workspaceContentId, workspaceContentVersionId = _a.workspaceContentVersionId, liveSendContentId = _a.liveSendContentId, userId = _a.userId, teamSiteId = _a.teamSiteId;
    return {
        /* This property is necessary for the WCF web service to know how to deserialize this event
           since the SeismicEventContainerData data contract on the server has a property that is a
           collection of EventData abstract class instances => IEnumerable<EventData> EventData */
        __type: 'ContentViewEventData',
        product: product,
        ipAddress: ipAddress,
        latitude: latitude,
        longitude: longitude,
        extraProperties: extraProperties,
        correlationId: correlationId,
        name: name,
        contentId: contentId,
        contentVersionId: contentVersionId,
        viewedTime: viewedTime,
        contentProfileId: contentProfileId,
        workspaceContentId: workspaceContentId,
        workspaceContentVersionId: workspaceContentVersionId,
        liveSendContentId: liveSendContentId,
        userId: userId,
        teamSiteId: teamSiteId,
    };
}
exports.default = createContentViewEventData;
//# sourceMappingURL=createContentViewEventData.js.map